import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VuetifyDialog from 'vuetify-dialog';
import 'vuetify-dialog/dist/vuetify-dialog.css';
import ja from 'vuetify/es5/locale/ja.js';
//import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

const vuetify = new Vuetify({
    lang: {
        locales: { ja },
        current: 'ja',
    },
    theme: {
        themes: {
            light: {
                primary: "#FFFFFF",
                nyuka: "#FB8C00",
                syukka: "#4CAF50",
                tana: "#CE4C77",
                centernyuko: "#FBBC05",
                centersyukko: "#329EF4",
                resultexport: "#778899"
               
            },
            dark: {
                primary: "#FFFFFF",
                nyuka: "#FB8C00",
                syukka: "#4CAF50",
                tana: "#CE4C77",
                centernyuko: "#FBBC05",
                centersyukko: "#329EF4",
                resultexport: "#778899"
            },
        },

        options: {
            customProperties: true
        }
    },
});

Vue.use(VuetifyDialog, {
    context: {
        vuetify
    }
});

export default vuetify;

const files = require.context('../components/shared', true, /\.vue$/);
const components = {};
files.keys().forEach(key => {
    components[key.replace(/(\.\/|\.vue)/g, '')] = files(key).default;
});

// 読み込んだvueファイルをグローバルコンポーネントとして登録
Object.keys(components).forEach(key => {
    Vue.component(key, components[key]);
});
